import React, { useState, useContext, useEffect } from "react";
import VerticalNavigation from "../components/VerticalNavigation";
import PlotData from "../context/PlotData";
import Scatterplot from "../components/Scatterplot";
import UnivariatePlot from "../components/UnivariatePlot";
import Heatmap from "../components/Heatmap";
import TSA from "../components/TSA";

const DataVizualization = () => {
  let { plotdata, getplotData, attributes, cat_attributes, getHeatmapData, corrdata, corrfeatures, nulldata } =
    useContext(PlotData);
  console.log('plot',plotdata)
  return (
    <>
      <div className="wrapper">
        <VerticalNavigation />
        <div className="container bg-light rounded main_content mx-2">
          <div className="modal-body">
            <ul className="nav nav-tabs" role="tablist">
              <li className="nav-item">
                <a
                  className="nav-link active"
                  data-bs-toggle="tab"
                  href="#profile"
                  role="tab"
                >
                  <span className="d-none d-sm-block" onClick={getplotData}>
                    Univariate
                  </span>
                </a>
              </li>
              <li className="nav-item">
                <a
                  className="nav-link "
                  data-bs-toggle="tab"
                  href="#home"
                  role="tab"
                >
                  <span className="d-none d-sm-block" onClick={getplotData}>
                    Bivariate
                  </span>
                </a>
              </li>

              <li className="nav-item">
                <a
                  className="nav-link "
                  data-bs-toggle="tab"
                  href="#tsa"
                  role="tab"
                >
                  <span className="d-none d-sm-block" onClick={getplotData}>
                    TSA
                  </span>
                </a>
              </li>

              <li className="nav-item">
                <a
                  className="nav-link "
                  data-bs-toggle="tab"
                  href="#heatmap"
                  role="tab"
                >
                  <span className="d-none d-sm-block" onClick={getHeatmapData}>
                    Heatmap
                  </span>
                </a>
              </li>
            </ul>

            {/* <!-- Tab panes --> */}
            <div className="tab-content p-3">
              <div className="tab-pane active" id="profile" role="tabpanel">
                <h3 className="text-center">Univariate Analysis</h3>
                <div className="d-flex justify-content-between flex-wrap">
                  {plotdata && (
                    <UnivariatePlot
                      plotdata={plotdata}
                      attributes={attributes}
                      cat_attributes={cat_attributes}
                    />
                  )}
                </div>
              </div>
              <div className="tab-pane" id="home" role="tabpanel">
                <h3 className="text-center">Bivariate Analysis</h3>
                <div className="d-flex justify-content-between flex-wrap">
                  {plotdata && (
                    <Scatterplot plotdata={plotdata} attributes={attributes} />
                  )}
                </div>
              </div>
              <div className="tab-pane" id="tsa" role="tabpanel">
                <h3 className="text-center">Time Series Analysis</h3>
                <div className="d-flex justify-content-between flex wrap">
                  { plotdata && (<TSA data={plotdata} attributes={attributes}/>)}
                </div>
              </div>

              <div className="tab-pane" id="heatmap" role="tabpanel">
                <h3 className="text-center">Heatmap</h3>
                <div className="d-flex justify-content-between flex wrap">
                  {corrdata && (<Heatmap corr_data={corrdata} corr_features={corrfeatures} null_data={nulldata} />)}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DataVizualization;
